import i18n from 'i18next';

import { formatDate } from '#common/utils';
import type { WearDateError } from '#common/validation/order';

// Map the i18n language ('en' | 'fr') to a BCP-47 tag for Intl formatters.
// 'en' stays 'en-US' so existing US output is byte-identical.
export function dateLocaleFor(language: string): string {
  if (language === 'fr') return 'fr-FR';
  return 'en-US';
}

// Render a shared-validator wear-date failure in the shopper's language, with
// the dates formatted for their locale in the market timezone.
export function translateWearDateError(err: WearDateError): string {
  const opts = { locale: dateLocaleFor(i18n.language), timeZone: err.timeZone };
  return i18n.t(`shop:wearDateError.${err.code}`, {
    count: err.days,
    shipDate: err.shipDate ? formatDate(err.shipDate, '', opts) : '',
    minDate: err.minDate ? formatDate(err.minDate, '', opts) : '',
  });
}
